import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonYpsiliLeftKentimata';
const args = {};

export class OligonYpsiliLeftKentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
